<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="toc-head">CONTENTS</p>
<p class="toc"><span href="#/ded01#ded-01" id="ded01" title="Link target outside of Sample">Dedication</span></p>
<p class="toc"><span href="#/epi01#epi-01" id="epi01" title="Link target outside of Sample">Epigraph</span></p>
<p class="toc"> </p>
<p class="toc"><a href="#/preface01#preface-01" id="preface01">Preface</a></p>
<p class="toc"><a href="#/cha01#cha-01" id="cha01">I - Into the Unknown</a></p>
<p class="toc"><a href="#/cha02#cha-02" id="cha02">II - Learning to Live</a></p>
<p class="toc"><span href="#/cha03#cha-03" id="cha03" title="Link target outside of Sample">III - Eggs, Guards, and Love</span></p>
<p class="toc"><span href="#/cha04#cha-04" id="cha04" title="Link target outside of Sample">IV - Medicines and Recipes, or How to Outwit Circumstances</span></p>
<p class="toc"><span href="#/cha05#cha-05" id="cha05" title="Link target outside of Sample">V - A Place of One’s Own</span></p>
<p class="toc"><span href="#/cha06#cha-06" id="cha06" title="Link target outside of Sample">VI - A Mixed Blessing</span></p>
<p class="toc"><span href="#/cha07#cha-07" id="cha07" title="Link target outside of Sample">VII - Sugar-and Politics</span></p>
<p class="toc"><span href="#/cha08#cha-08" id="cha08" title="Link target outside of Sample">VIII - Threat of Anarchy</span></p>
<p class="toc"><span href="#/cha09#cha-09" id="cha09" title="Link target outside of Sample">IX - Saints, Priests, and Preachers</span></p>
<p class="toc"><span href="#/cha10#cha-10" id="cha10" title="Link target outside of Sample">X - More Saints, Priests, and Preachers</span></p>
<p class="toc"><span href="#/cha11#cha-11" id="cha11" title="Link target outside of Sample">XI - Living for What?</span></p>
<p class="toc"><span href="#/cha12#cha-12" id="cha12" title="Link target outside of Sample">XII - Rescue from the Clouds</span></p>
<p class="toc"><span href="#/cha13#cha-13" id="cha13" title="Link target outside of Sample">XIII - Last Days at Weihsien</span></p>
<p class="toc"><span href="#/cha14#cha-14" id="cha14" title="Link target outside of Sample">XIV - After It Was All Over</span></p>
<p class="toc"> </p>
<p class="toc"><span href="#/copy01#copy-01" id="copy01" title="Link target outside of Sample">Copyright</span></p>
<p class="toc"><span href="#/atp01#atp01" id="ata_01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc01.vue?e4260dda